/* eslint semi: 1 */

export const LICENSE_STATES = {
  /**
   * The license has no serial number set, it is not present on any
   * player; this is the initial state of a license after creation.
   */
  UNASSIGNED: 'unassigned',
  /**
   * The license has had a serial number set and is in the process
   * of being sent to the player or waiting to be downloaded.
   */
  ASSIGN_PENDING: 'assign-pending',
  /**
   * Indicates that the license has been successfully activated on the player,
   * it may have been generated and send to the player without the TPM,
   * depending on the firmware version.
   */
  ASSIGNED: 'assigned',
  /**
   * The license was ASSIGNED and is now in the process of being revoked
   * and removed from the player and the serial number will be cleared
   * when it completes, the next state is UNASSIGNED.
   */
  REVOKE_PENDING: 'revoke-pending',
  /** The license is in a terminal state and is bound to the player. */
  UNMOVABLE: 'unmovable',
  /**
   * The license was ASSIGNED and is now in the process of being
   * revoked and removed from the player but the serial number
   * will not be cleared when it completes, the next state
   * is SUSPENDED.
   */
  SUSPEND_PENDING: 'suspend-pending',
  /**
   * The license has a serial number set, but it has been
   * revoked and removed from the player and thus not
   * effective.
   */
  SUSPENDED: 'suspended',
  /**
   * The license was suspended and is transitioning back to assigned,
   * waiting for the process of sending a license to the player to
   * complete; next state is ASSIGNED.
   */
  RESTORE_PENDING: 'restore-pending'
};
